export class ShipmentDetails{
    name:string;
    value:string|boolean;
}